// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"a2a4b53d","255":"b7a2d24a","348":"aadde0f2","673":"a15df5b1","742":"e2cf5c62","802":"5d8336df"}[chunkId] + ".chunk.js";
};